import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import PricingRow from "../PricingRow";

const Delivery = ({ storeCode, text, name, formatTranslation }) => {
  if (storeCode !== "COM" || !text) {
    return null;
  }

  return (
    <PricingRow>
      <p>
        {formatTranslation("minibag_delivery_title")}
        {name ? ` (${name})` : null}
      </p>
      <div data-test-id="miniBagDelivery">{text}</div>
    </PricingRow>
  );
};

Delivery.defaultProps = {
  text: null,
  name: null
};

Delivery.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  text: PropTypes.string,
  name: PropTypes.string,
  storeCode: PropTypes.string.isRequired
};

export default withTranslation(Delivery);
